// Customers.js
import React from "react";
import { Row, Col, Image } from "react-bootstrap";
import "./CustomerComponent.css";
import { Link } from "react-router-dom";
const handleImageError = (e) => {
  e.target.style.display = "none";
  e.target.nextElementSibling.style.display = "flex";
};
const CustomerComponent = ({ customers }) => {
  return (
    <div className="customers-list">
      {customers.map((customer, index) => (
        <Row key={index} className="align-items-center customer-item py-2">
          <Col xs={2} className="text-center">
            <div className="image-container">
              <Image
                src={customer.imageUrl}
                roundedCircle
                width={50}
                height={50}
                alt={customer.name}
                className="customer-image"
                onError={handleImageError}
              />
              <div className="user-icon1" style={{ display: "none" }}>
                {customer.name?.charAt(0)}
              </div>
            </div>
          </Col>
          <Col xs={6}>
            <h5 className="m-0">{customer.name}</h5>
          </Col>
          <Col xs={4} className="text-end">
            {/* <a href={customer.profileLink} >
              
            </a> */}
            <Link
              key={index}
              to={customer.profileLink}
              state={{ farmer: customer.state }} // Pass the farmer as state
              rel="noopener noreferrer"
              className="view-profile-link"
            >
              View Profile
            </Link>
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default CustomerComponent;
